import Toastify from 'toastify-js'

// Function to show a toast notification using Toastify
export function showToast(message, type = 'info') {
  // Define colors based on type
  let backgroundColor;
  
  switch (type) {
    case 'success':
      backgroundColor = '#36d399';
      break;
    case 'error':
      backgroundColor = '#f87272';
      break;
    case 'warning':
      backgroundColor = '#fbbd23';
      break;
    case 'info':
    default:
      backgroundColor = '#3abff8';
      break;
  }
  
  // Create and show toast
  Toastify({
    text: message,
    duration: 5000,
    gravity: "top",
    position: "right",
    style: {
      background: backgroundColor,
    },
    stopOnFocus: true,
    close: true,
    className: `pc-toast pc-toast--${type} rounded-md shadow-lg`,
  }).showToast();
}

export function showActionToast({ message, type = 'info', actionLabel, onAction, duration = 8000 }) {
  let backgroundColor;

  switch (type) {
    case 'success':
      backgroundColor = '#36d399';
      break;
    case 'error':
      backgroundColor = '#f87272';
      break;
    case 'warning':
      backgroundColor = '#fbbd23';
      break;
    case 'info':
    default:
      backgroundColor = '#3abff8';
      break;
  }

  const content = document.createElement('div');
  content.className = 'pc-toast__content flex min-w-0 items-center gap-3 text-sm';

  const text = document.createElement('span');
  text.className = 'min-w-0 flex-1 leading-5';
  text.textContent = message;
  content.appendChild(text);

  if (actionLabel && typeof onAction === 'function') {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'rounded-full bg-white/20 px-3 py-1 text-xs font-semibold uppercase tracking-wide hover:bg-white/30';
    button.textContent = actionLabel;
    button.addEventListener('click', (event) => {
      event.stopPropagation();
      onAction();
    });
    content.appendChild(button);
  }

  Toastify({
    node: content,
    duration,
    gravity: "top",
    position: "right",
    style: {
      background: backgroundColor,
    },
    stopOnFocus: true,
    close: true,
    className: `pc-toast pc-toast--${type} rounded-md shadow-lg`,
  }).showToast();
}

// Function to set up HTMX event listeners for toasts
export function setupToastListeners() {
  document.body.addEventListener('htmx:afterOnLoad', function(event) {
    const triggerHeader = event.detail.xhr.getResponseHeader('HX-Trigger');
    console.log(triggerHeader)
    if (triggerHeader) {
      try {
        const triggers = JSON.parse(triggerHeader);

        // Handle new multi-message format (showToast-0, showToast-1, etc.)
        Object.keys(triggers).forEach(key => {
          if (key.startsWith('showToast-')) {
            const toastData = triggers[key];
            showToast(toastData.message, toastData.type);
          }
        });
      } catch (error) {
        console.error('Error parsing HX-Trigger header:', error);
      }
    }
  });

  // Expose showToast to window for global access if needed
  window.showToast = showToast;
  window.showActionToast = showActionToast;
}
